
export const generateModalIDTag = (index, suffix, prefix = "") =>
  `${prefix}modal-${index}-${suffix}`
